import React, { useEffect, useState } from "react";
import Button from "../../../../components/ui/Button";
import Card from "../../../../components/ui/card";
import { Edit, Globe, LinkIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function ContactComponent({
    editingContact,
    isEditing,
    startEditingContact,
    editedProfile,
    handleCompanyFieldChange,
    validationCompanyErrors,
    handleSocialLinkChange,
    profileData,
    validationPersonalErrors,
    handleContactSaveChanges,
    setEditingContact,
    isCurrentUser = true,
    showEditIcon = true,
    canEdit = true,
    shouldMaskSensitiveInfo = false,
}) {
    const { t } = useTranslation();
    return (
        <>
            {" "}
            <Card color={undefined} className="p-4 w-full">
                <h2 className="text-lg font-semibold mb-4 flex items-center justify-between">
                    {t("contactComponent.title")}
                    {!editingContact && !isEditing && isCurrentUser && showEditIcon && canEdit && (
                        <Button
                            variant="ghost"
                            size="sm"
                            onClick={startEditingContact}
                            className="text-blue-600 hover:text-blue-700">
                            <Edit className="h-4 w-4" />
                        </Button>
                    )}
                </h2>
                {editingContact || isEditing ? (
                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">{t("contactComponent.companyWebsite")}</label>
                            <input
                                type="url"
                                value={editedProfile.company?.website || ""}
                                onChange={e => handleCompanyFieldChange("website", e.target.value)}
                                className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500 text-sm"
                            />
                            {validationCompanyErrors.company?.website && (
                                <p className="text-red-500 text-xs mt-1">{validationCompanyErrors.company.website}</p>
                            )}
                        </div>
                        <h3 className="text-sm font-medium mt-6 mb-2">{t("contactComponent.socialProfiles")}</h3>
                        {editedProfile.socialLinks?.length > 0 ? (
                            editedProfile.socialLinks.map((item, index) => (
                                <div key={index}>
                                    <input
                                        type="url"
                                        value={item}
                                        onChange={e => handleSocialLinkChange(index, e.target.value)}
                                        className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500 text-sm"
                                    />
                                </div>
                            ))
                        ) : (
                            <div>
                                <input
                                    type="url"
                                    value=""
                                    onChange={e => handleSocialLinkChange(0, e.target.value)}
                                    className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500 text-sm"
                                    placeholder={t("contactComponent.enterSocialUrl")}
                                />
                            </div>
                        )}
                        {validationPersonalErrors.personal?.socialLinks && (
                            <p className="text-red-500 text-xs mt-1">{validationPersonalErrors.personal.socialLinks}</p>
                        )}
                        <div className="flex justify-end gap-2">
                            <Button variant="outline" className="text-sm" onClick={() => setEditingContact(false)}>
                                {t("contactComponent.cancel")}
                            </Button>
                            <Button className="text-sm" onClick={handleContactSaveChanges}>
                                {t("contactComponent.save")}
                            </Button>
                        </div>
                    </div>
                ) : (
                    <div className="space-y-3 text-sm">
                        <div className="flex items-center gap-2">
                            <Globe className="w-4 h-4 text-gray-400" />
                            {profileData.personal.company?.website ? (
                                <a
                                    href={profileData.personal.company.website}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 hover:underline">
                                    {profileData.personal.company.website}
                                </a>
                            ) : (
                                <span className="text-gray-500">{t("contactComponent.noWebsiteProvided")}</span>
                            )}
                        </div>
                        <div className="mt-4 pt-4 border-t">
                            <h3 className="text-sm font-medium mb-2">{t("contactComponent.socialProfiles")}</h3>
                            <div className="space-y-2 text-sm">
                                {profileData.personal.socialLinks?.length > 0 ? (
                                    profileData.personal.socialLinks.map((item, index) => (
                                        <a
                                            key={index}
                                            href={item.startsWith("http") ? item : `https://${item}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700">
                                            <LinkIcon className="w-4 h-4" />
                                            {item}
                                        </a>
                                    ))
                                ) : (
                                    <span className="text-gray-500">{t("contactComponent.noSocialLinksProvided")}</span>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </Card>
        </>
    );
}
